import { useAlertConfig, useAlertUiTranslation } from '../../../../../../hooks';
import { useFormRow } from '../../Components/useFormRow';
export function useDeliveryMethodPanel(config) {
    const { t } = useAlertUiTranslation();
    const { notificationOptions, availableChannels } = useAlertConfig();
    const deliveryMethods = availableChannels && availableChannels.length > 0 ? availableChannels : [];
    const mandatoryChannels = notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.mandatoryChannels;
    return {
        type: 'form.panel',
        key: '!deliveryMethods',
        style: {
            layout: 'column',
            paddingTop: config === null || config === void 0 ? void 0 : config.paddingTop,
            surface: 'level1',
        },
        children: [
            useFormRow([
                {
                    type: 'form.content',
                    key: 'content',
                    template: {
                        data: '',
                        content: `<div style="display: flex; align-items: center"> <span class="icon-forward-to-inbox-outlined grey-700"></span> <p style="font-size: 20px; padding-left: 16px" class="subtitle1"> ${t('wizard.defineDelivery.deliveryMethod')}</p></div>`,
                    },
                },
                {
                    type: 'form.panel',
                    key: '!channelsPanel',
                    style: {
                        paddingLeft: config.mode === 'edit' ? 56 : 49,
                    },
                    children: [
                        {
                            type: 'form.label',
                            hidden: {
                                custom: (handler) => {
                                    var _a;
                                    if (((_a = handler.formParams) === null || _a === void 0 ? void 0 : _a.features) && handler.formParams.features.showPhin) {
                                        return !handler.formData.phin;
                                    }
                                    return true;
                                },
                            },
                            template: {
                                data: '',
                                content: '<div style="border-radius: 4px; padding: 8px; background: #E2F1FD; display: flex; align-items: center;">\n  <span class="icon-error-outline theme-accent-blue-bold" style="padding-right: 8px; padding-left: 8px"></span>\n  <p class="Color body2 theme-accent-blue-bold" style="font-size: 14px; font-weight: 500">“Inbox” is a required delivery method for PHIN direct communications.</p>\n</div>',
                            },
                        },
                        {
                            type: 'alert.deliveryMethods',
                            key: 'channels',
                            values: [
                                ...deliveryMethods.map((deliveryMethod) => {
                                    return {
                                        value: deliveryMethod,
                                        label: t(`common.channels.${deliveryMethod}`),
                                        disabled: !!(mandatoryChannels === null || mandatoryChannels === void 0 ? void 0 : mandatoryChannels.includes(deliveryMethod)),
                                    };
                                }),
                                {
                                    value: 'inbox',
                                    label: t('common.channels.inbox'),
                                    disabled: !!(mandatoryChannels === null || mandatoryChannels === void 0 ? void 0 : mandatoryChannels.includes('inbox')) || config.phinSelected,
                                },
                            ],
                            validate: {
                                required: true,
                                requiredMessage: t('wizard.defineDelivery.deliveryMethodRequired'),
                            },
                        },
                    ],
                },
            ], config.mode, '!deliveryChannelsLayout'),
        ],
    };
}
